/* ==========================================================================
   B2B-pagina, nieuwe versie (template page.b2b-v2)

   Eén script voor alle B2B-secties. Elke sectie hangt zijn eigen haakjes
   (data-bn-...) aan de HTML; dit script zoekt ze op de hele pagina, want de
   keuzekaarten, het formulier en de vaste balk staan in aparte secties.
   Staat een onderdeel er niet, dan slaat het script dat stuk over.

   Alle zichtbare teksten komen uit instellingen van de secties (data-
   attributen), zodat ze via Translate & Adapt vertaald kunnen worden. In dit
   bestand staat geen enkele zin voor de bezoeker.
   ========================================================================== */
(() => {
  'use strict';

  /* Meerdere secties laden dit bestand. Een browser voert dezelfde script-tag
     elke keer opnieuw uit, en dan reageert elke klik twee keer en heft zich op.
     Daarom start het script maar één keer per pagina. */
  if (window.bnNieuwGeladen) return;
  window.bnNieuwGeladen = true;

  const q = (sel, root) => (root || document).querySelector(sel);
  const qa = (sel, root) => Array.from((root || document).querySelectorAll(sel));

  /* API-versie van Klaviyo voor alle aanroepen vanuit de browser. */
  const KLAVIYO_REVISIE = '2026-10-15';

  /* Klaviyo bewaart de taal van een profiel als taalcode met regio (BCP 47,
     bijvoorbeeld nl-BE). Alleen "nl" is geen volwaardige waarde. De taal komt
     van de pagina (nl, en of fr), de regio van het land van de markt
     (Shopify.country) en anders BE. */
  function klaviyoLocale(taal) {
    const t = String(taal || '').slice(0, 2).toLowerCase();
    if (!/^[a-z]{2}$/.test(t)) return '';
    const land = String((window.Shopify && window.Shopify.country) || '').toUpperCase();
    return t + '-' + (/^[A-Z]{2}$/.test(land) ? land : 'BE');
  }

  /* --- Meten ------------------------------------------------------------ */

  window.dataLayer = window.dataLayer || [];
  const track = (event, params) => {
    window.dataLayer.push(Object.assign({ event: event }, params || {}));
  };

  document.addEventListener('click', (e) => {
    const knop = e.target.closest('[data-bn-cta]');
    if (knop) track('b2b_cta_klik', { locatie: knop.dataset.bnCta });
  }, true);

  /* --- Kleine hulpjes --------------------------------------------------- */

  const pad = (n) => (n < 10 ? '0' : '') + n;
  const isoLokaal = (d) => d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
  const vul = (tekst, waarden) =>
    String(tekst || '').replace(/\[(\w+)\]/g, (m, sleutel) => (sleutel in waarden ? waarden[sleutel] : m));
  const opnieuw = (el, klasse) => {
    el.classList.remove(klasse);
    void el.offsetWidth;
    el.classList.add(klasse);
  };

  /* --- Hero-video ------------------------------------------------------- */

  function initVideo() {
    const wrap = q('[data-bn-video]');
    const knop = q('[data-bn-videoknop]');
    const vid = wrap && q('video', wrap);
    if (!vid || !knop) return;

    let doorGebruikerGepauzeerd = false;
    const zetKnop = (gepauzeerd) => {
      knop.classList.toggle('is-gepauzeerd', gepauzeerd);
      knop.setAttribute('aria-label', gepauzeerd ? knop.dataset.labelSpeel : knop.dataset.labelPauze);
    };
    const speel = () => {
      const belofte = vid.play();
      if (belofte && belofte.catch) belofte.catch(() => {});
    };

    const verminderd = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (verminderd) {
      vid.removeAttribute('autoplay');
      vid.pause();
      doorGebruikerGepauzeerd = true;
      zetKnop(true);
    }

    knop.addEventListener('click', () => {
      if (vid.paused) {
        doorGebruikerGepauzeerd = false;
        speel();
        zetKnop(false);
      } else {
        doorGebruikerGepauzeerd = true;
        vid.pause();
        zetKnop(true);
      }
    });

    if ('IntersectionObserver' in window) {
      new IntersectionObserver((items) => {
        if (doorGebruikerGepauzeerd) return;
        if (items[0].isIntersecting) speel();
        else vid.pause();
      }, { threshold: 0.1 }).observe(vid);
    }
  }

  /* --- Keuzekaarten en offerteformulier --------------------------------- */

  function initAanvraag() {
    const form = q('[data-bn-form]');
    if (!form) return;

    const picks = qa('[data-bn-kies]');
    const opties = qa('input[data-bn-opt]', form);
    const radioNaam = 'contact[Personalisatie gewenst]';
    const optsWrap = q('[data-bn-opts-wrap]', form);
    const optsT = q('[data-bn-opts-t]', form);
    const interesse = q('[data-bn-interesse]', form);
    const pre = q('[data-bn-pre]', form);
    const preT = q('[data-bn-pre-t]', form);
    const occ = q('[data-bn-occ]', form);
    const occWrap = q('[data-bn-occ-wrap]', form);
    const datum = q('[data-bn-datum]', form);
    const warn = q('[data-bn-warn]', form);

    const bar = q('[data-bn-bar]');
    const barV = q('[data-bn-bar-v]');
    const barM = q('[data-bn-bar-m]');
    const live = q('[data-bn-live]');
    const sbN = q('[data-bn-sb-n]');

    const teksten = form.dataset;
    const barTeksten = bar ? bar.dataset : {};
    const LEEG = barV ? barV.textContent : '';
    let voorinvulGelegenheid = '';

    const vandaag = new Date();
    vandaag.setHours(0, 0, 0, 0);
    if (datum) datum.min = isoLokaal(vandaag);

    const weken = (w) => (w === 1 ? teksten.weekEen : vul(teksten.weekMeer, { n: w }));
    const cbVoor = (naam) => form.querySelector('input[data-bn-opt="' + naam + '"]');
    const pickVoor = (naam) => document.querySelector('[data-bn-kies="' + naam + '"]');
    const persWaarde = () => {
      const r = form.querySelector('input[name="' + radioNaam + '"]:checked');
      return r ? r.value : '';
    };
    const zetPers = (v) => {
      qa('input[name="' + radioNaam + '"]', form).forEach((r) => { r.checked = (r.value === v); });
    };
    const gekozen = () => opties.filter((c) => c.checked).map((c) => c.dataset.bnOpt);
    /* Intern blijft de naam vast (die komt in de e-mail); op het scherm tonen
       we de naam van de kaart, in de taal van de bezoeker. */
    const label = (naam) => {
      const b = pickVoor(naam);
      return (b && b.dataset.label) || naam;
    };

    function updateOpts() {
      if (!optsWrap) return;
      const v = persWaarde();
      optsWrap.hidden = !(v === teksten.waardeJa || v === teksten.waardeMisschien);
      if (optsT) optsT.textContent = v === teksten.waardeJa ? teksten.optsKop : teksten.optsKopOptioneel;
    }

    function controleerDatum() {
      if (!datum || !warn) return;
      if (!datum.value) { warn.hidden = true; return; }
      const gekozenDatum = new Date(datum.value + 'T00:00:00');
      const pers = persWaarde();
      let dagen = 0;
      let bericht = '';

      if (pers === teksten.waardeNee) {
        dagen = 5;
        bericht = teksten.warnZonder;
      } else {
        let langste = 0;
        let naam = '';
        gekozen().forEach((n) => {
          const w = +cbVoor(n).dataset.weeks;
          if (w > langste) { langste = w; naam = n; }
        });
        if (langste) {
          dagen = langste * 7;
          bericht = vul(teksten.warnMet, { optie: label(naam), tijd: weken(langste) });
        }
      }

      const vroegst = new Date(vandaag);
      vroegst.setDate(vroegst.getDate() + dagen);
      if (dagen && gekozenDatum < vroegst) {
        warn.textContent = bericht + ' ' + teksten.warnSlot;
        warn.hidden = false;
      } else {
        warn.hidden = true;
      }
    }

    function sync() {
      const namen = gekozen();

      picks.forEach((b) => {
        const cb = cbVoor(b.dataset.bnKies);
        const aan = !!(cb && cb.checked);
        b.setAttribute('aria-pressed', aan ? 'true' : 'false');
        const kaart = b.closest('[data-bn-kaart]');
        if (kaart) kaart.classList.toggle('is-aan', aan);
      });

      if (interesse) {
        interesse.value = namen.join(', ');
        /* Uitgeschakeld zolang er niets in staat: dan komt het veld ook niet
           leeg in de e-mail van Shopify terecht. */
        interesse.disabled = namen.length === 0;
      }

      const delen = [];
      if (voorinvulGelegenheid && occ && occ.value === voorinvulGelegenheid) delen.push(voorinvulGelegenheid);
      if (namen.length) delen.push(namen.map(label).join(', '));
      if (pre && preT) {
        pre.hidden = delen.length === 0;
        preT.textContent = delen.join(' · ');
      }

      if (bar && barV && barM) {
        bar.classList.toggle('heeft', namen.length > 0);
        if (namen.length) {
          let min = 0;
          let langste = 0;
          namen.forEach((n) => {
            const b = pickVoor(n);
            if (!b) return;
            min = Math.max(min, +b.dataset.min);
            langste = Math.max(langste, +b.dataset.weeks);
          });
          barV.textContent = namen.map(label).join(' · ');
          barM.textContent = vul(barTeksten.meta, { min: min, weken: weken(langste) });
          barM.hidden = false;
        } else {
          barV.textContent = LEEG;
          barM.hidden = true;
        }
      }

      if (sbN) {
        sbN.hidden = namen.length === 0;
        sbN.textContent = namen.length;
      }

      controleerDatum();
    }

    picks.forEach((b) => {
      b.addEventListener('click', () => {
        const naam = b.dataset.bnKies;
        const cb = cbVoor(naam);
        if (!cb) return;
        const aan = !cb.checked;
        cb.checked = aan;
        if (aan && persWaarde() !== teksten.waardeJa) zetPers(teksten.waardeJa);
        updateOpts();
        sync();

        const kaart = b.closest('[data-bn-kaart]');
        if (kaart) {
          if (aan) opnieuw(kaart, 'pop');
          else kaart.classList.remove('pop');
        }
        if (bar) opnieuw(bar, 'flash');
        track('b2b_optie_gekozen', { optie: naam, aan: aan });
        if (sbN && !sbN.hidden) opnieuw(sbN, 'bump');
        if (live && barTeksten.liveAan) {
          live.textContent = vul(aan ? barTeksten.liveAan : barTeksten.liveUit, { naam: label(naam) });
        }
      });
    });

    qa('[data-bn-gelegenheid]').forEach((a) => {
      a.addEventListener('click', () => {
        if (!occ) return;
        const waarde = a.dataset.bnGelegenheid;
        const bestaat = Array.from(occ.options).some((o) => o.value === waarde || o.text === waarde);
        if (!bestaat) return;
        voorinvulGelegenheid = waarde;
        occ.value = waarde;
        sync();
        if (occWrap) setTimeout(() => opnieuw(occWrap, 'flash'), 450);
      });
    });

    let gestart = false;
    form.addEventListener('focusin', () => {
      if (!gestart) {
        gestart = true;
        track('form_start', { formulier: 'b2b_offerte' });
      }
    });

    form.addEventListener('change', (e) => {
      if (occ && e.target === occ && occ.value !== voorinvulGelegenheid) voorinvulGelegenheid = '';
      if (e.target.name === radioNaam) {
        if (e.target.value === teksten.waardeNee) opties.forEach((c) => { c.checked = false; });
        updateOpts();
      }
      sync();
    });

    if (datum) datum.addEventListener('input', controleerDatum);

    updateOpts();
    sync();
  }

  /* --- Brochures per e-mail (via een Klaviyo-flow) ----------------------- */

  /* Het adres en de keuze voor nieuws gaan als gebeurtenis naar Klaviyo. De
     flow in Klaviyo stuurt dan de brochures. Dit gebruikt de openbare
     Klaviyo-sleutel van de winkel (company_id) en werkt dus los van de
     cookiekeuze: de bezoeker geeft zijn adres zelf in. */
  function initBrochureMail() {
    const form = q('[data-bn-bmail]');
    if (!form) return;

    const email = q('[data-bn-bm-email]', form);
    const nieuws = q('[data-bn-bm-nieuws]', form);
    const fout = q('[data-bn-bm-fout]', form);
    const mislukt = q('[data-bn-bm-mislukt]', form);
    const ok = q('[data-bn-bm-ok]', form);
    const knop = q('button[type="submit"]', form);

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      if (mislukt) mislukt.hidden = true;
      if (ok) ok.hidden = true;
      if (!email.value || !email.checkValidity()) {
        fout.hidden = false;
        email.focus();
        return;
      }
      fout.hidden = true;
      if (knop) knop.disabled = true;

      const d = form.dataset;
      let lijst = [];
      try { lijst = JSON.parse(d.brochures || '[]'); } catch (_) { lijst = []; }
      const eigenschappen = {
        taal: document.documentElement.lang || '',
        nieuws_b2b: nieuws && nieuws.checked ? 'ja' : 'nee',
        brochures: lijst,
        pagina: window.location.href
      };

      const profielBrochure = {
        email: email.value.trim(),
        properties: { b2b_nieuws: eigenschappen.nieuws_b2b, taal: eigenschappen.taal }
      };
      const localeBrochure = klaviyoLocale(eigenschappen.taal);
      if (localeBrochure) profielBrochure.locale = localeBrochure;
      const stuurBrochure = (attributen) => klaviyoVerstuur('events', d.klaviyoId, {
        data: {
          type: 'event',
          attributes: {
            properties: eigenschappen,
            metric: { data: { type: 'metric', attributes: { name: d.gebeurtenis } } },
            profile: { data: { type: 'profile', attributes: attributen } },
            time: new Date().toISOString()
          }
        }
      });

      /* Weigert Klaviyo het verzoek (400), dan proberen we het één keer zonder
         locale, zodat de aanvraag altijd binnenkomt. */
      stuurBrochure(profielBrochure).then((r0) => {
        if (r0 && r0.status === 400 && profielBrochure.locale) {
          const zonder = Object.assign({}, profielBrochure);
          delete zonder.locale;
          return stuurBrochure(zonder);
        }
        return r0;
      }).then((r) => {
        if (!r.ok) throw new Error('klaviyo ' + r.status);
        ok.hidden = false;
        track('b2b_brochure_mail', { nieuws: eigenschappen.nieuws_b2b });
      }).catch(() => {
        if (mislukt) mislukt.hidden = false;
      }).then(() => {
        if (knop) knop.disabled = false;
      });
    });

    email.addEventListener('input', () => {
      if (!fout.hidden && email.checkValidity()) fout.hidden = true;
    });
  }

  /* --- Vaste balk onderaan (mobiel) ------------------------------------- */

  function initBalk() {
    const balk = q('[data-bn-sticky]');
    if (!balk || !('IntersectionObserver' in window)) return;
    const zichtbaar = new Set();
    const io = new IntersectionObserver((items) => {
      items.forEach((i) => {
        if (i.isIntersecting) zichtbaar.add(i.target);
        else zichtbaar.delete(i.target);
      });
      balk.classList.toggle('is-weg', zichtbaar.size > 0);
    }, { threshold: 0.12 });
    qa('[data-bn-verberg-balk]').forEach((el) => io.observe(el));
  }

  /* --- Keuzebalk blijft in beeld tot het formulier (desktop) ------------ */

  function initKeuzebalk() {
    const bar = q('[data-bn-bar]');
    const sectie = bar && bar.closest('section');
    if (!bar || !sectie) return;
    const form = document.getElementById('aanvraag');
    const breed = window.matchMedia('(min-width: 750px)');

    const plek = document.createElement('div');
    plek.className = 'bn-bar-plek';
    plek.hidden = true;
    bar.parentNode.insertBefore(plek, bar);

    let wacht = false;
    function update() {
      wacht = false;
      const vh = window.innerHeight;
      let vast = false;
      if (breed.matches && bar.classList.contains('heeft')) {
        const r = (plek.hidden ? bar : plek).getBoundingClientRect();
        const h = plek.hidden ? r.height : parseFloat(plek.style.height) || r.height;
        const sr = sectie.getBoundingClientRect();
        const gestart = sr.top < vh - 80;
        const slotZichtbaar = r.top < vh - h - 16 && r.bottom > 0;
        const formNabij = form ? form.getBoundingClientRect().top < vh - 120 : false;
        vast = gestart && !slotZichtbaar && !formNabij;
      }
      if (vast === bar.classList.contains('is-vast')) return;
      if (vast) {
        plek.style.height = bar.getBoundingClientRect().height + 'px';
        plek.hidden = false;
      } else {
        plek.hidden = true;
      }
      bar.classList.toggle('is-vast', vast);
    }
    function plan() {
      if (wacht) return;
      wacht = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', plan, { passive: true });
    window.addEventListener('resize', plan);
    if (breed.addEventListener) breed.addEventListener('change', plan);
    new MutationObserver(plan).observe(bar, { attributes: true, attributeFilter: ['class'] });
    // Secties laden soms pas na het scrollen op hun echte hoogte: ook dan opnieuw rekenen.
    if ('ResizeObserver' in window) new ResizeObserver(plan).observe(document.body);
    if (form && 'IntersectionObserver' in window) {
      new IntersectionObserver(plan, { rootMargin: '0px 0px -120px 0px' }).observe(form);
    }
    update();
  }

  /* --- Meten: offerteaanvraag en brochures ------------------------------- */

  /* Elke gebeurtenis gaat naar de dataLayer en naar Shopify's eigen meetlaag
     (Shopify.analytics.publish). Daar luisteren de pixels in Shopify naar.
     Staat de Meta-pixel rechtstreeks op de pagina (fbq), dan sturen we de
     gebeurtenis daar ook naartoe. Persoonsgegevens gaan enkel naar Klaviyo. */
  const meld = (naam, data) => {
    track(naam, data);
    try {
      const sa = window.Shopify && window.Shopify.analytics;
      if (sa && typeof sa.publish === 'function') sa.publish(naam, data);
    } catch (_) { /* meten mag de pagina nooit storen */ }
  };
  const naarMeta = (naam, data) => {
    try { if (typeof window.fbq === 'function') window.fbq('track', naam, data); } catch (_) { /* idem */ }
  };

  /* Telefoonnummer omzetten naar het internationale formaat dat Klaviyo
     vraagt (+32472123456). Klaviyo weigert anders het hele verzoek, het event
     inbegrepen. Geeft een lege tekst als het resultaat geen geldig nummer is. */
  function telefoonVoorKlaviyo(ruw) {
    let t = String(ruw || '').replace(/\(0\)/g, '').replace(/[\s.\-()/]/g, '');
    if (t.indexOf('00') === 0) t = '+' + t.slice(2);
    else if (t.charAt(0) === '0') t = '+32' + t.slice(1);
    /* Een overbodige 0 na de landcode (+32 0472...) kan Klaviyo niet lezen. */
    t = t.replace(/^\+(31|32|33|44|49)0/, '+$1');
    return /^\+[1-9]\d{7,14}$/.test(t) ? t : '';
  }

  function klaviyoVerstuur(soort, sleutel, body) {
    return fetch('https://a.klaviyo.com/client/' + soort + '/?company_id=' + encodeURIComponent(sleutel), {
      method: 'POST',
      keepalive: true,
      headers: { 'Content-Type': 'application/json', revision: KLAVIYO_REVISIE },
      body: JSON.stringify(body)
    });
  }

  /* Leest uit een 400-antwoord van Klaviyo welke profielvelden geweigerd zijn.
     Lukt het lezen niet binnen drie seconden, dan geldt "onbekend" en laten we
     bij de herpoging beide velden weg. */
  function geweigerdeVelden(r) {
    const onbekend = { locale: false, telefoon: false };
    const lees = Promise.resolve().then(() => r.clone().json()).then((j) => {
      const tekst = JSON.stringify((j && j.errors) || []);
      return { locale: /locale/i.test(tekst), telefoon: /phone_number/i.test(tekst) };
    }).catch(() => onbekend);
    const wacht = new Promise((klaar) => { setTimeout(() => klaar(onbekend), 3000); });
    return Promise.race([lees, wacht]);
  }

  function naarKlaviyo(sleutel, metric, profiel, eigenschappen, ruwTelefoon) {
    if (!sleutel || !metric || !profiel.email) return;
    const bouw = (attributen) => ({
      data: {
        type: 'event',
        attributes: {
          properties: eigenschappen,
          metric: { data: { type: 'metric', attributes: { name: metric } } },
          profile: { data: { type: 'profile', attributes: attributen } },
          time: new Date().toISOString()
        }
      }
    });
    try {
      klaviyoVerstuur('events', sleutel, bouw(profiel)).then((r) => {
        /* Weigert Klaviyo het verzoek (400) door een standaardveld dat het niet
           aanvaardt, dan sturen we het event nog één keer zonder dat veld, zodat
           de aanvraag altijd binnenkomt. Klaviyo noemt het geweigerde veld in
           errors[].source.pointer. Staat daar geen van onze velden bij, dan
           laten we phone_number en locale allebei weg. Een geweigerd nummer
           blijft bewaard als eigen property. */
        if (!r || r.status !== 400 || !(profiel.phone_number || profiel.locale)) return;
        return geweigerdeVelden(r).then((g) => {
          const beide = !g.locale && !g.telefoon;
          const zonder = Object.assign({}, profiel);
          if (g.locale || beide) delete zonder.locale;
          if (g.telefoon || beide) delete zonder.phone_number;
          if (profiel.phone_number && !zonder.phone_number && ruwTelefoon) {
            zonder.properties = Object.assign({}, profiel.properties, { telefoon: ruwTelefoon });
          }
          return klaviyoVerstuur('events', sleutel, bouw(zonder)).then((r2) => {
            /* Noemde Klaviyo maar één veld per melding, dan kan het andere veld
               ook fout zijn. Als laatste vangnet sturen we het event zonder
               beide velden. */
            if (!r2 || r2.status !== 400 || !(zonder.phone_number || zonder.locale)) return;
            const kaal = Object.assign({}, zonder);
            delete kaal.phone_number;
            delete kaal.locale;
            if (profiel.phone_number && ruwTelefoon) {
              kaal.properties = Object.assign({}, profiel.properties, { telefoon: ruwTelefoon });
            }
            return klaviyoVerstuur('events', sleutel, bouw(kaal));
          });
        });
      }).catch(() => {});
    } catch (_) { /* idem */ }
  }

  /* Wie het nieuwsvakje aanvinkt, wordt ook echt ingeschreven op de lijst.
     Klaviyo legt zelf het tijdstip en de bron van de toestemming vast. */
  function schrijfInVoorNieuws(sleutel, lijst, email) {
    if (!sleutel || !lijst || !email) return;
    try {
      klaviyoVerstuur('subscriptions', sleutel, {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'B2B offerteformulier',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: lijst } } }
        }
      }).catch(() => {});
    } catch (_) { /* idem */ }
  }

  function initOfferteMeting() {
    const wrap = q('[data-bn-form]');
    const form = wrap && q('form', wrap);
    if (!form) return;

    const OPSLAG = 'bnOfferte';
    const veld = (naam) => { const el = form.elements[naam]; return el ? (el.value || '').trim() : ''; };
    const vn = q('[data-bn-vn]', form);
    const an = q('[data-bn-an]', form);
    const naamVeld = q('[data-bn-naam]', form);
    const zetNaam = () => {
      if (naamVeld) naamVeld.value = [vn && vn.value.trim(), an && an.value.trim()].filter(Boolean).join(' ');
    };
    form.addEventListener('input', zetNaam);
    zetNaam();

    /* Bij het versturen bewaren we de antwoorden even. De pagina laadt daarna
       opnieuw met de bevestiging, en pas dan melden we de aanvraag: zo telt
       een mislukte verzending niet mee. */
    form.addEventListener('submit', () => {
      zetNaam();
      const data = {
        tijd: Date.now(),
        email: veld('contact[email]'),
        voornaam: veld('contact[Voornaam]'),
        achternaam: veld('contact[Achternaam]'),
        telefoon: veld('contact[phone]'),
        bedrijf: veld('contact[Bedrijfsnaam]'),
        aantal: veld('contact[Aantal geschenken]'),
        budget: veld('contact[Budget per geschenk]'),
        gelegenheid: veld('contact[Gelegenheid]'),
        leverdatum: veld('contact[Gewenste leverdatum]'),
        personalisatie: veld('contact[Personalisatie gewenst]'),
        opties: qa('input[data-bn-opt]:checked', form).map((c) => c.dataset.bnOpt).join(', '),
        levering: veld('contact[Levering]'),
        nieuws_b2b: form.elements['contact[Nieuws B2B]'] && form.elements['contact[Nieuws B2B]'].checked ? 'ja' : 'nee'
      };
      try { window.sessionStorage.setItem(OPSLAG, JSON.stringify(data)); } catch (_) { /* geen opslag: dan geen melding */ }
    });

    /* Bij elke paginalading wissen we de bewaarde antwoorden, ook zonder
       bevestiging: een mislukte of afgebroken verzending laat zo geen
       e-mailadres achter in de browser, en kan later geen valse aanvraag
       melden. Een bewaring van meer dan een half uur oud telt niet mee. */
    let data = null;
    try {
      data = JSON.parse(window.sessionStorage.getItem(OPSLAG) || 'null');
      window.sessionStorage.removeItem(OPSLAG);
    } catch (_) { data = null; }
    if (!q('[data-bn-gelukt]', wrap)) return;
    if (!data || !data.tijd || Date.now() - data.tijd > 30 * 60 * 1000) return;

    const taal = document.documentElement.lang || '';
    meld('b2b_offerte_aangevraagd', {
      formulier: 'b2b_offerte',
      aantal: data.aantal,
      gelegenheid: data.gelegenheid,
      personalisatie: data.personalisatie,
      opties: data.opties,
      nieuws_b2b: data.nieuws_b2b,
      taal: taal
    });
    naarMeta('Lead', { content_name: 'B2B offerte', content_category: 'b2b' });
    /* Standaardvelden van het Klaviyo-profiel: organization, locale (taal en
       regio, bijvoorbeeld nl-BE) en phone_number. Is het nummer geen geldig
       internationaal nummer, dan laten we phone_number weg en bewaren we het
       als eigen property telefoon. */
    const locale = klaviyoLocale(taal);
    const telefoon = telefoonVoorKlaviyo(data.telefoon);
    const profiel = { email: data.email, first_name: data.voornaam, last_name: data.achternaam };
    if (data.bedrijf) profiel.organization = data.bedrijf;
    if (locale) profiel.locale = locale;
    if (telefoon) profiel.phone_number = telefoon;
    else if (data.telefoon) profiel.properties = { telefoon: data.telefoon };

    naarKlaviyo(wrap.dataset.klaviyoId, wrap.dataset.gebeurtenis, profiel, {
      bedrijf: data.bedrijf,
      aantal: data.aantal,
      budget: data.budget,
      gelegenheid: data.gelegenheid,
      leverdatum: data.leverdatum,
      personalisatie: data.personalisatie,
      opties: data.opties,
      levering: data.levering,
      nieuws_b2b: data.nieuws_b2b,
      taal: taal,
      pagina: window.location.pathname
    }, data.telefoon);

    if (data.nieuws_b2b === 'ja') {
      schrijfInVoorNieuws(wrap.dataset.klaviyoId, wrap.dataset.klaviyoLijst || 'RJhPbs', data.email);
    }
  }

  /* De brochureformulieren zijn Klaviyo-formulieren. Klaviyo meldt een
     verzending met de gebeurtenis "klaviyoForms". Alleen formulieren in het
     hoofdgedeelte van de pagina tellen mee, niet de pop-up of de footer. */
  function initBrochureMeting() {
    window.addEventListener('klaviyoForms', (e) => {
      const d = (e && e.detail) || {};
      if (d.type !== 'submit' || !d.formId) return;
      if (!q('#MainContent .klaviyo-form-' + d.formId)) return;
      meld('b2b_brochure_aangevraagd', {
        formulier: 'b2b_brochure',
        klaviyo_formulier: d.formId,
        taal: document.documentElement.lang || ''
      });
      naarMeta('Lead', { content_name: 'B2B brochure', content_category: 'b2b' });
    });
  }

  /* --- Starten ---------------------------------------------------------- */

  initVideo();
  initAanvraag();
  initBrochureMail();
  initBalk();
  initKeuzebalk();
  initOfferteMeting();
  initBrochureMeting();
})();
